import { Outlet } from 'react-router-dom';
import AppShell from '../AppShell';

/**
 * Layout route — wraps all child routes in AppShell.
 * Uses Outlet to render matched child routes.
 */
export default function Layout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
